import { routing } from "../../routing.js";
import { Query, SortOrder } from "../../types/index.js"; // Not putting these into the `./types` module to keep it local.
export function createClient(api) {
  async function list(options = {}) {
    const {
      sortOrder
    } = options;
    const {
      tags
    } = await api.get(routing.contactTagsUrl, {
      query: {
        sort: SortOrder.stringify(sortOrder)
      }
    });
    return {
      tags
    };
  }
  async function search(options = {}) {
    const {
      query,
      sortOrder
    } = options;
    const {
      tags
    } = await api.get(routing.contactTagsUrl, {
      query: {
        sort: SortOrder.stringify(sortOrder),
        query: Query.stringify(query)
      }
    });
    return {
      tags
    };
  }
  async function get(id) {
    const url = `${routing.contactTagsUrl}/${id}`;
    const {
      tag
    } = await api.get(url);
    return tag;
  }
  async function create(payload, {
    force = false
  } = {}) {
    const data = await api.post(routing.contactTagsUrl, {
      payload,
      query: {
        force: force || undefined // Convert `false` to `undefined`
      }
    });
    return {
      tag: data.tag,
      deleted: data.deleted_tags_ids
    };
  }
  async function update(id, payload, {
    force = false
  } = {}) {
    const url = `${routing.contactTagsUrl}/${id}`;
    const data = await api.patch(url, {
      payload,
      query: {
        force: force || undefined // Convert `false` to `undefined`
      }
    });
    return {
      tag: data.tag,
      deleted: data.deleted_tags_ids
    };
  }
  async function merge({
    name,
    tags
  }) {
    const url = `${routing.contactTagsUrl}/merge`;
    const data = await api.post(url, {
      payload: {
        name,
        tags
      }
    });
    return {
      tag: data.tag,
      deleted: data.deleted_tags_ids
    };
  }
  async function doDelete(id) {
    const url = `${routing.contactTagsUrl}/${id}`;
    const data = await api.delete(url);
    return {
      deleted: data.deleted_tags_ids
    };
  }
  async function doDeleteMany(ids) {
    const data = await api.post(routing.contactTagsDeleteManyUrl, {
      payload: {
        id: ids
      }
    });
    return {
      deleted: data.deleted_tags_ids
    };
  }
  async function doDeleteUnused() {
    const data = await api.post(routing.contactTagsDeleteManyUrl, {
      payload: {
        filter: 'unused'
      }
    });
    return {
      deleted: data.deleted_tags_ids
    };
  }
  return {
    list,
    search,
    get,
    create,
    update,
    merge,
    delete: doDelete,
    deleteMany: doDeleteMany,
    deleteUnused: doDeleteUnused
  };
}